// src/components/modals/DeliveryProviderPopup.jsx
import { useState } from 'react'
import { Car, Truck, X } from 'lucide-react'

const DeliveryProviderPopup = ({ isOpen, onClose, onProviderSelect }) => {
  const [selectedProvider, setSelectedProvider] = useState(null)
  const [orderReference, setOrderReference] = useState('')

  const handleProviderSelect = (provider) => {
    setSelectedProvider(provider)
  }

  const handleConfirm = () => {
    if (selectedProvider) {
      onProviderSelect(selectedProvider, orderReference)
      // Reset state
      setSelectedProvider(null)
      setOrderReference('')
    }
  }

  const handleCancel = () => {
    setSelectedProvider(null)
    setOrderReference('')
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 shadow-xl max-w-sm w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-center flex-1">Select Delivery Provider</h3>
          <button
            onClick={handleCancel}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>
        
        {/* Provider Selection */}
        <div className="space-y-3 mb-4">
          <button
            onClick={() => handleProviderSelect('pickme')}
            className={`w-full px-4 py-4 rounded-lg transition-colors font-medium flex items-center justify-center gap-3 ${
              selectedProvider === 'pickme' 
                ? 'bg-green-600 text-white' 
                : 'bg-green-500 text-white hover:bg-green-600'
            }`}
          >
            <Car className="h-5 w-5" />
            <span>PickMe</span>
          </button>
          <button
            onClick={() => handleProviderSelect('uber')}
            className={`w-full px-4 py-4 rounded-lg transition-colors font-medium flex items-center justify-center gap-3 ${
              selectedProvider === 'uber' 
                ? 'bg-gray-800 text-white' 
                : 'bg-black text-white hover:bg-gray-800'
            }`}
          >
            <Truck className="h-5 w-5" />
            <span>Uber</span>
          </button>
        </div>

        {/* Order Reference Input */}
        {selectedProvider && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Last Digit of Order ID (Optional)
            </label>
            <input
              type="text"
              value={orderReference}
              onChange={(e) => setOrderReference(e.target.value.slice(0, 10))} // Limit to 10 characters
              placeholder="e.g., 123, ABC, etc."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              maxLength={10}
            />
            <p className="text-xs text-gray-500 mt-1">
              Enter any reference for this {selectedProvider === 'pickme' ? 'PickMe' : 'Uber'} order
            </p>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={handleCancel}
            className="flex-1 px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          {selectedProvider && (
            <button
              onClick={handleConfirm}
              className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
            >
              Confirm
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default DeliveryProviderPopup
